import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    productCurrent:0
  },
  getters: {
  },
  mutations: {
    setProductCurrent(state,productCurrent){
      state.productCurrent = productCurrent
      console.log('触发')
    }
  },
  actions: {
  },
  modules: {
  }
})
